export enum RuleEntitlementMethod {
User,
NormalLeave,
Illness,
}
